
const formatearFechaCorta = (fechaRaw) => {
    if (!fechaRaw) return "";
    
    // Forzamos a string por seguridad y cortamos los primeros 10 caracteres
    return String(fechaRaw).trim().substring(0, 10);
};
export const mapEmpleadoRow = (item) => ({
    id: item.msuAdicionalId,
    msuId: item.msuId,
    SFHotelId: item.SFHotelId,
    rolId: item.rolId,
    rolCod: item.rolCod,
    rolNombre: item.rolNombre,
    usuarioNroDeDocumentoX: item.usuarioNroDeDocumentoX,
    usuarioApellidos: item.usuarioApellidos,
    usuarioNombres: item.usuarioNombres,
    usuarioFechaDeNacimiento: formatearFechaCorta(item.usuarioFechaDeNacimiento),
    usuarioSexo: item.usuarioSexo,
    tipoDeDocumentoCod: item.tipoDeDocumentoCod,
    msuAdicionalVersion: item.msuAdicionalVersion
});

export const mapEmpleadoList = (result) => {
    if (!Array.isArray(result) || !result[0]?.SFHotelId) {
        return [];
    }
    return result.map((item) => mapEmpleadoRow(item));
};
